import { useEffect, useState, VFC } from 'react'
import ReactSlick, { Settings as ReactSlickSettings } from 'react-slick'
import { createMyPageActionLog } from 'src/api/mypage'
import { Link } from 'src/elements/Link'
import { Advertisement } from 'src/models/Advertisement'
import { truewhite } from 'src/styles/colors'
import { WIDTH_THRESHOLD } from 'src/styles/mixins'
import styled from 'styled-components'

type AdvertisementsProps = {
  advertisements: Advertisement[]
}
export const Advertisements: VFC<AdvertisementsProps> = ({
  advertisements,
}) => {
  const [width, setWidth] = useState(window.innerWidth)
  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth)
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const isTab = width < WIDTH_THRESHOLD
  const slidesToShowCount = isTab ? 1 : 2
  const slidesToShow = Math.min(slidesToShowCount, advertisements.length)

  const settings: ReactSlickSettings = {
    autoplay: true,
    autoplaySpeed: 4000,
    dots: true,
    infinite: true,
    speed: 500,
    centerMode: true,
    initialSlide: 1,
    variableWidth: true,
  }

  const onClick = (id: number) => {
    createMyPageActionLog({
      component: 'Advertisements',
      item: 'advertisement',
      targetObjectId: id,
    })
  }
  return (
    <>
      {/* NOTE: 3つ以上の広告がある場合、paddingを追加 */}
      <AdvertisementsLayout length={advertisements.length}>
        <ReactSlick arrows={false} slidesToShow={slidesToShow} {...settings}>
          {advertisements.map((advertisement) => (
            <ContentLink
              key={advertisement.id}
              href={advertisement.url}
              onClick={() => onClick(advertisement.id)}
            >
              <Image src={advertisement.imageSource} alt="" />
            </ContentLink>
          ))}
        </ReactSlick>
      </AdvertisementsLayout>
    </>
  )
}

const AdvertisementsLayout = styled.div<{ length: number }>`
  padding-top: 40px;
  ${({ length }) => (length === 1 ? 'max-width: 500px;' : 'max-width: 1000px;')}
  margin: 0 auto;

  .slick-track {
    display: flex;
  }
`

const ContentLink = styled(Link)`
  cursor: pointer;
  display: inline-block;
`

const Image = styled.img`
  max-width: 403px;
  margin: 0 10px;
  @media screen and (max-width: 960px) {
    max-width: 313px;
  }
  height: 135px;
  object-fit: contain;
  background-color: ${truewhite};
`
